// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file documents/v3alpha/resources.proto (package com.seed.documents.v3alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetResourceRequest, ListCitationsRequest, ListCitationsResponse, PushResourcesToPeerRequest, Resource } from "./resources_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { AnnounceBlobsProgress } from "../../p2p/v1alpha/syncing_pb";

/**
 * Service for querying Hypermedia resources.
 *
 * Note: This API had to be separate to avoid circular dependencies between documents and comments.
 *
 * @generated from service com.seed.documents.v3alpha.Resources
 */
export const Resources = {
  typeName: "com.seed.documents.v3alpha.Resources",
  methods: {
    /**
     * Gets a single resource with a URL (technically IRI).
     *
     * @generated from rpc com.seed.documents.v3alpha.Resources.GetResource
     */
    getResource: {
      name: "GetResource",
      I: GetResourceRequest,
      O: Resource,
      kind: MethodKind.Unary,
    },
    /**
     * Lists citations of a given resource across the locally-available content.
     *
     * @generated from rpc com.seed.documents.v3alpha.Resources.ListCitations
     */
    listCitations: {
      name: "ListCitations",
      I: ListCitationsRequest,
      O: ListCitationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Makes sure a resource (and their related blobs) are pushed to a given peer.
     *
     * @generated from rpc com.seed.documents.v3alpha.Resources.PushResourcesToPeer
     */
    pushResourcesToPeer: {
      name: "PushResourcesToPeer",
      I: PushResourcesToPeerRequest,
      O: AnnounceBlobsProgress,
      kind: MethodKind.ServerStreaming,
    },
  }
} as const;

